export interface OnboardingMessage {
	title: string;
	description: string;
	footer: string;
}

export interface OnboardingMessageContext {
	showFooter: boolean;
	showGotIt: boolean;
	data: OnboardingMessage;
}
